module.exports = __webpack_public_path__ + "img/Compliance New.e9b600f9.svg";